// extracted by mini-css-extract-plugin
module.exports = {"Adv":"adv_Adv__OVQUJ","AdvList":"adv_AdvList___NYgN","AdvListRow_2":"adv_AdvListRow_2__rVZ1Q","AdvListRow_3":"adv_AdvListRow_3__4ukQX"};